import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const PrivateRoute = ({ children, role }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "student" && user.profile_complete === false && window.location.pathname !== "/enroll") {
    return <Navigate to="/enroll" replace />;
  }
  const allowed = Array.isArray(role) ? role : (role ? [role] : null);
  if (allowed && !allowed.includes(user.role)) {
    const home = {
      teacher: "/teacher/dashboard", student: "/student/dashboard",
      admin: "/admin/dashboard",     parent:  "/parent/dashboard",
    }[user.role] || "/login";
    return <Navigate to={home} replace />;
  }
  return children;
};
